import { FC, useState, useEffect } from 'react';
import { CustomEditor, ImageUpload, Input, SelectInput } from '../../../commons';
import { useCountries } from '../../../../hooks';
import PlaceBlocks from './sections/PlaceBlocks';

interface PlaceFormProps {
  values: any;
  setFieldValue: any;
}

const PlaceForm: FC<PlaceFormProps> = ({ values, setFieldValue }) => {
  const [initialValue, setInitialValue] = useState(values.description);
  const { countries, loading: countryLoading } = useCountries();

  const handleImageChange = (e: any) => {
    const file = e.target.files[0];
    setFieldValue('file', file);
    setFieldValue('imageCover', URL.createObjectURL(file));
  };

  useEffect(() => {
    setFieldValue('description', initialValue);
  }, [initialValue]);

  const countriesOptions = countries.map((country: any) => ({
    value: country.id,
    label: country.name,
  }));

  return (
    <div className='space-y-6'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        <Input type='text' name='name' label='Place Name' />
        <Input type='text' name='location' label='Location' />
      </div>

      <Input type='text' name='descriptionTitle' label='Description Title' />

      <div className='space-y-2'>
        <label className='block text-sm font-bold text-gray-700 dark:text-gray-300'>
          Description
        </label>
        <CustomEditor
          placeholder='Type place description here...'
          onChange={setInitialValue}
          value={initialValue}
          name='description'
        />
      </div>

      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 items-start'>
        <div className='md:col-span-2'>
          <SelectInput
            name='country'
            label='Country'
            placeholder='Select Country'
            value={values.country}
            setFieldValue={setFieldValue}
            options={countriesOptions}
            isLoading={countryLoading}
          />
        </div>
        <div className='md:col-span-1'>
          <label className='block text-sm font-bold text-gray-700 dark:text-gray-300 mb-2'>
            Featured Image
          </label>
          <ImageUpload tourImage={values.imageCover} tourImageHandler={handleImageChange} />
        </div>
      </div>

      <PlaceBlocks values={values} setFieldValue={setFieldValue} />
    </div>
  );
};

export default PlaceForm;
